import { Component, OnInit } from '@angular/core';
import { AdDataService } from '../services/addata.service';
import { UserdataService } from '../services/userdata.service';
import { Router } from '@angular/router';
import { environment } from '../app.constant';
import { AdbookingService } from '../services/adbooking.service';

class displayadModelinf {
  adcategory: any;
  location: any;
  free: any;
  frees: any;
  choosedAd: any;
  customradio: any;
  basicrate: any;
  widthinput: any;
  heightinput: any;
  adsizeinsqcm: any;
  uploadbtn: any;
  adsize: any;
  adcost: any;
  adContent: any;
  adContentPreview: any;
  igst: any;
  cgst: any;
  sgst: any;
  totalCost: any;
  imagename: string;
  adtype: string;
  adpage: string;
  flagupload: any;
  flagdate: any;
  email: any;
  addate: any;
  trxnid: any;
  fileData: File;
  uploadedFilePath: string;
  selectedDate: any;
  noOfAdDays: any;
  noofdays: any;
  freedays: any;
  constructor() {
    this.location = null;
    this.free = null;
    this.frees = null;
    this.freedays = null;
    this.adcategory = null;
    this.choosedAd = null;
    this.customradio = null;
    this.basicrate = null;
    this.widthinput = null;
    this.heightinput = null;
    this.adsizeinsqcm = null;
    this.uploadbtn = null;
    this.adsize = null;
    this.adcost = null;
    this.adContent = null;
    this.adContentPreview = null;
    this.igst = null;
    this.cgst = null;
    this.sgst = null;
    this.totalCost = null;
    this.imagename = null;
    this.adtype = null;
    this.adpage = null;
    this.flagupload = null;
    this.flagdate = null;
    this.noOfAdDays = null;
    this.noofdays = null;
    this.email = null;
    this.addate = null;
    this.trxnid = null;
    this.fileData = null;
    this.uploadedFilePath = null;
    this.selectedDate = null;
  }

}

@Component({
  selector: 'app-adsummary2',
  templateUrl: './adsummary2.component.html',
  styleUrls: ['./adsummary2.component.css']
})
export class Adsummary2Component implements OnInit {
  displayadModel = {
    country: null,
    free: null,
    location: null,
    frees: null,
    freedays: null,
    adcategory: null,
    choosedAd: null,
    customradio: null,
    basicrate: null,
    widthinput: null,
    heightinput: null,
    adsizeinsqcm: null,
    uploadbtn: null,
    adsize: null,
    adcost: null,
    adContent: null,
    adContentPreview: null,
    igst: null,
    cgst: null,
    sgst: null,
    totalCost: null,
    imagename: null,
    adtype: null,
    adpage: null,
    flagupload: null,
    flagdate: null,
    noOfAdDays: null,
    noofdays: null,
    email: null,
    addate: null,
    trxnid: null,
    fileData: null,
    uploadedFilePath: null,
    selectedDate: null,
    touched: null,
    custid: null,
    orderid: null,
    guestid: null,
    address: null,
    isGuest: null,
    username: null,
    mobilenumber: null,
    state: null,
    zip: null,
    city: null,
  };

  adDetails = {
    free: '',
    frees: '',
    freedays: '',
    adcategory: '',
    location: '',
    choosedAd: '',
    customradio: '',
    basicrate: '',
    widthinput: '',
    heightinput: '',
    adsizeinsqcm: '',
    uploadbtn: '',
    adContent: '',
    adContentPreview: '',
    adsize: '',
    adcost: '',
    gst: 0,
    totalCost: '',
    imagename: '',
    adtype: '',
    adpage: '2nd Page',
    noOfAdDays: '',
    noofdays: '',
    email: '',
    addate: '',
    trxnid: '',
    flagupload: true,
    flagdate: true,
    fileData: File = null,
    uploadedFilePath: '',
    selectedDate: [] = '',
    touched: ''
  };


  selectedDates: any;

  cost: any;
  user: any;
  free: any;
  frees: any;
  freedays: string;
  merchantId = '258936';
  tid: any;
  torderid: any;
  // requiredParam = {
  //   billing_name: null,
  //   billing_address: 'nvl',
  //   billing_city: 'nvl',
  //   billing_state: 'nvl',
  //   billing_zip: '90',
  //   billing_country: 'nvl',
  //   billing_tel: null,
  //   billing_email: null,
  // };
  ccaResponseurl: string;
  ccaRequesturl: string;
  ccaCancelPaymentUrl: string;
  isUserAddressValid: boolean;



  constructor(
    private addata: AdDataService,
    private userdataservice: UserdataService,
    private router: Router,
    private adbookingService: AdbookingService
  ) {
    this.tid = new Date().getTime();
    this.torderid = 'TORID' + this.tid;
    this.ccaResponseurl = environment.apiHost + '/postrespccav';
    this.ccaRequesturl = environment.apiHost + '/posttestccav';
    this.ccaCancelPaymentUrl = environment.apiHost + '/ccaCancelPayment';
    this.user = this.userdataservice.getUserData();
    if (this.user && Boolean(this.user.address) && Boolean(this.user.city) && Boolean(this.user.state) && Boolean(this.user.zip)) {
      this.isUserAddressValid = true;
    } else {
      this.isUserAddressValid = false;
    }
    // this.requiredParam.billing_email = this.userdataservice.getUserData().email;
    // this.requiredParam.billing_name = this.userdataservice.getUserData().username;
    // this.requiredParam.billing_tel = this.userdataservice.getUserData().mobilenumber;
    const ssdata = JSON.parse(sessionStorage.getItem('Array'));
    const serdata = this.addata.getAdData();
    this.displayadModel = (serdata) ? serdata : ssdata;
    // const obj=this.addata.getAdData();
    // obj.adsummary=this.displayadModel;
    // console.log(obj.adsummary);
    // console.log( this.displayadModel);
    // this.noofdays = sessionStorage.getItem("noOfAdDays");
    // console.log(this.noofdays);
    // this.displayadModel.noofdays = this.noofdays;
    this.selectedDates = sessionStorage.getItem('selectedDate');
    this.free = sessionStorage.getItem('free');
    this.frees = sessionStorage.getItem('frees');
    this.freedays = sessionStorage.getItem('freedays');
    console.log(this.selectedDates);
    console.log(this.free);
    console.log(this.frees);
    console.log(this.freedays);
    console.log(this.displayadModel.noOfAdDays);
    this.displayadModel.noofdays = sessionStorage.getItem('noOfAdDays');
    this.displayadModel.freedays = this.freedays;
    this.displayadModel.selectedDate = this.selectedDates;
    this.displayadModel.noofdays = this.displayadModel.noOfAdDays;
    if (this.displayadModel.freedays === 1) {
    this.displayadModel.free = this.free;
    }
    if (this.displayadModel.freedays === 2) {
      this.displayadModel.free = this.free;
      this.displayadModel.frees = this.frees;
  }
    if (this.displayadModel.location !== 'Meghalaya') {
    if (this.displayadModel.adcost) {

      this.cost = parseFloat(this.displayadModel.adcost) * parseFloat(this.displayadModel.noOfAdDays);
      this.displayadModel.igst = (parseFloat(this.cost) * 5.00 / 100).toFixed(2);


      this.displayadModel.totalCost = (parseFloat(this.displayadModel.igst) + parseFloat(this.cost)).toFixed(2);

      // this.displayadModel.basicrate = this.displayadModel.customrado;
      sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));

      let obj = this.addata.getAdData();
      obj = this.displayadModel;
      this.addata.setAdData(obj);
    }
  }
    if (this.displayadModel.location === 'Meghalaya') {
    if (this.displayadModel.adcost) {

      this.cost = parseFloat(this.displayadModel.adcost) * parseFloat(this.displayadModel.noOfAdDays);

      this.displayadModel.cgst = (parseFloat(this.cost) * 2.5 / 100).toFixed(2);
      this.displayadModel.sgst = (parseFloat(this.cost) * 2.5 / 100).toFixed(2);

      this.displayadModel.totalCost = (parseFloat(this.cost)
      + parseFloat(this.displayadModel.cgst) + parseFloat(this.displayadModel.sgst)).toFixed(2);

      // this.displayadModel.basicrate = this.displayadModel.customrado;
      sessionStorage.setItem('Array', JSON.stringify(this.displayadModel));

      let obj = this.addata.getAdData();
      obj = this.displayadModel;
      this.addata.setAdData(obj);
    }
  }
  }

  pay() {
    if (this.user == null) {
      this.router.navigate(['/register']);
    } else {
      this.router.navigate(['/paymentmethod1']);
    }
  }


  fileSave(id) {
    console.log('file saved');
    const file = this.displayadModel.fileData;
    this.adbookingService.savefile(file, this.torderid).subscribe(data => {
      console.log(data);
      console.log(this.userdataservice.getUserData());
      this.displayadModel.address = this.userdataservice.getUserData().address;
      this.displayadModel.isGuest = this.userdataservice.getUserData().isGuest;
      this.displayadModel.username = this.userdataservice.getUserData().username;
      this.displayadModel.email = this.userdataservice.getUserData().email;
      this.displayadModel.mobilenumber = this.userdataservice.getUserData().mobilenumber;
      this.displayadModel.state = this.userdataservice.getUserData().state;
      this.displayadModel.city = this.userdataservice.getUserData().city;
      this.displayadModel.zip = this.userdataservice.getUserData().zip;
      this.displayadModel.country = 'India';
      console.log(this.displayadModel);
      setTimeout(() => {
        $('#payformsubmit').trigger('click');
      }, 1000);
    });
  }

  ngOnInit() {




    this.displayadModel = JSON.parse(sessionStorage.getItem('Array'));
    const obj = this.addata.getAdData();
    this.displayadModel = (obj) ? obj : this.adDetails;
    console.log(obj);
    // this.displayadModel.custid = this.userdataservice.getUserData().custid;
    // this.displayadModel.email = this.userdataservice.getUserData().email;
  }

  ngOnDestroy() {
    // this.userdataservice.getUserData().unsubscribe();
  }

  async paynow() {
    this.displayadModel.custid = this.userdataservice.getUserData().custid;
    this.displayadModel.email = this.userdataservice.getUserData().email;
  }



  }



